import { render, staticRenderFns } from "./Statistik.vue?vue&type=template&id=741ea74d&scoped=true"
import script from "./Statistik.vue?vue&type=script&lang=js"
export * from "./Statistik.vue?vue&type=script&lang=js"
import style0 from "./Statistik.vue?vue&type=style&index=0&id=741ea74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ea74d",
  null
  
)

export default component.exports